import React from 'react';
import { MdOutlineLightbulb } from 'react-icons/md'; // AI/ML Solutions
import { MdOutlineCloudQueue } from 'react-icons/md'; // Cloud & Edge Scaling
import { MdOutlineSpeed } from 'react-icons/md'; // Optimization
import { MdOutlineBuild } from 'react-icons/md'; // Automation
import { FaLightbulb, FaPencilRuler, FaRocket, FaCogs } from 'react-icons/fa';
import { GoGraph } from 'react-icons/go';
import { LuBrain } from "react-icons/lu";
import { BsListColumnsReverse } from "react-icons/bs";
import { AiOutlineCloudSync } from "react-icons/ai";
import { GiRecycle } from "react-icons/gi";

export default function MainSection1() {
  return (
    <div>
      <div className="mt-6 px-4 py-4 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
        <div className="flex flex-col justify-center mb-6 lg:justify-center lg:flex-row md:mb-8">
          <h2 className="max-w-4xl mb-5 font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none md:mb-6 group">
            <span className="inline-block mb-1 sm:mb-4">
              Why Choose Aero Aegis for Logistics & Supply Chain?
            </span>
            <div className="h-1 ml-auto duration-300 origin-left transform bg-primary scale-x-30 group-hover:scale-x-100" />
          </h2>
        </div>

        <section className="py-4 bg-base-100">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-8 lg:gap-8">
              {[
                {
                  icon: <LuBrain />,
                  title: 'End-to-End Optimization',
                  description:
                    'From fleet management to last-mile delivery, we provide comprehensive solutions that improve every aspect of your logistics operations.',
                },
                {
                  icon: <AiOutlineCloudSync />,
                  title: ' Scalable Solutions',
                  description:
                    'Our expertise in IoT, AI, Blockchain, and Cloud Computing ensures your logistics ecosystem can scale effortlessly with business growth.',
                },
                {
                  icon: <BsListColumnsReverse />,
                  title: 'Enhanced Visibility and Transparency',
                  description:
                    'Real-time tracking, predictive analytics, and blockchain-enabled traceability create seamless visibility across the supply chain.',
                },
                {
                  icon: <GiRecycle />,
                  title: 'Sustainability-Driven',
                  description:
                    'We help businesses achieve sustainability goals with energy-efficient operations and optimized resource utilization.',
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="card border border-primary shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 w-full"
                >
                  <div className="card-body items-center text-center">
                    <div className="text-4xl text-primary mb-4">
                      {item.icon}
                    </div>
                    <h3 className="card-title text-xl mb-2 min-h-[60px]">{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
